import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  MAX_FILE_SIZE,
  ARTICLE_CONTENT_TYPES,
  MAX_PDF_FILE_SIZE,
  Invalid_Youtube_Video_URL,
  Unsupported_file_format,
  Maximum_file_size_540kb,
  format_not_allowed,
  Max_file_size_10MB
} from '@root/app.constant';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { MatSelectChange } from '@angular/material/select';
import { NgForm } from '@angular/forms';
import { ArticleData } from '../catalogue-article.model';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { KeyValue } from '@common/models/key-value.model';
import { FileInputComponent } from '@common/file-input/file-input';

@Component({
  selector: 'app-catalogue-articles-form',
  templateUrl: './catalogue-articles-form.component.html',
  styleUrls: ['./catalogue-articles-form.component.scss'],
  providers: [CatalogService],
})
export class CatalogueArticlesFormComponent implements OnInit, OnChanges {
  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) {}
  @ViewChild('f', { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false })  fileInputComponent: FileInputComponent;

  @Output() typeChange = new EventEmitter<string>();

  @Input() articleData: ArticleData;

  @Input() enableCeoSpecificFields: boolean;


  file: File;

  fileName: string;

  @Input() typeList : any;

  selectedContentType = 'IMAGE';

  availableContentTypes: KeyValue[] = ARTICLE_CONTENT_TYPES;

  selectedYear: string;

  selectedMonth: string;

  yearList = [];

  monthList = []; 

  shortDescription: string;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Add the description...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarHiddenButtons: [
      [],
      [
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'customClasses',
        'textColor',
        'backgroundColor',
      ],
    ],
  };

  ngOnInit() {
    this.readYear();
    this.readMonth();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['articleData'] && this.articleData) {
      if (this.articleData.video) {
        this.selectedContentType = 'VIDEO';
      } else if (this.articleData.pdfUrl) {
        this.selectedContentType = 'PDF';
      } else {
        this.selectedContentType = 'IMAGE';
      }
    }
  }

  public processData() {
    this.addOrUpdateArticle();
  }

  public addOrUpdateArticle() {
    if (this.articleData.video) {
      const validVedioURL = this.articleData.video.startsWith('https://www.youtube.com/watch?');
      if (validVedioURL) {
        this.toastr.error(Invalid_Youtube_Video_URL);
        return;
      }
    }
    const formData: any = new FormData();
    const service = this.file
      ? this.catalogService.addOrUpdateArticle(formData)
      : this.catalogService.addOrUpdateArticle(this.articleData);
  

    if (this.file) {
      formData.append('file', this.file);
      formData.append('type', this.articleData.type);
      formData.append('title', this.articleData.title);
      formData.append('year', this.articleData.year);
      formData.append('month', this.articleData.month);
      formData.append('shortDesc', this.articleData.shortDesc);
      formData.append('htmlContent', this.articleData.htmlContent);
      if (this.articleData.video) {
        formData.append(this.articleData.video);
      }

      // ---update case
      if (this.articleData.id) {
        formData.append('id', this.articleData.id);
      }else{
        formData.append('id', null);
      }
    }

    service.subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.emitTypeChange(this.articleData.type);
          this.resetForm(this.articleData.type);
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public addMedia() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append('type', this.articleData.type);
    formData.append('title', this.articleData.title);
    formData.append('year', this.articleData.year);
    formData.append('month', this.articleData.month);
    formData.append('shortDesc', this.articleData.shortDesc);
    formData.append('htmlContent', this.articleData.htmlContent);
    this.catalogService.addMedia(this.articleData.type, formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.emitTypeChange(this.articleData.type);
          this.resetForm(this.articleData.type);
        } else {
          this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      if (this.selectedContentType === 'IMAGE') {
        this.validateImage();
      } else {
        this.validatePdf();
      }
    } else {
      this.fileName = null;
    }
  }

  private validateImage() {
    let isValid =  true;
    const fsize = this.file.size;
    if (fsize > MAX_FILE_SIZE) {
      this.toastr.error(Maximum_file_size_540kb);
     isValid = false;
     this.clearFileComponent();
    }else if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
      this.toastr.error(format_not_allowed);
      isValid = false;
      this.clearFileComponent();
    }
  }

  private validatePdf() {
    if (this.file) {
      let isValid = true
      if (this.file.type !== 'application/pdf') {
        this.toastr.error(Unsupported_file_format);
       isValid = false;
       this.clearFileComponent();
      }else if (this.file.size > MAX_PDF_FILE_SIZE) {
        this.toastr.error(Max_file_size_10MB);
        isValid = false;
        this.clearFileComponent();
      }
    } else {
      this.fileName = null;
    }
  }

  private clearFileComponent(){
    if( this.fileInputComponent){
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
    }
  }

  public onTypeChange(change: MatSelectChange) {
    this.articleData = new ArticleData();
    this.articleData.type = change.value;
    this.emitTypeChange(this.articleData.type);
  }

  public emitTypeChange(type: string) {
    this.typeChange.emit(type);
  }

  private resetForm(type?: string) {
    this.form.resetForm();
    setTimeout(() => {
      this.articleData = new ArticleData();
      this.articleData.type = type;
    });
  }

  public readYear(){
    const obj = {
      flag : ''
    }
    this.catalogService.getYear(obj).subscribe(
      response => {
        if (response.status === 0) {
          this.yearList = response.data.yearList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public readMonth(){
    this.catalogService.getMonth().subscribe(
      response => {
        if (response.status === 0) {
          this.monthList = response.data.monthList;
        }
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

}
